import { Card } from 'flowbite-react';

type HistoryItem = {
  dateTime: string;
  title: string;
  roleLabel: string;
  userName: string;
};

const mockHistory: HistoryItem[] = [
  {
    dateTime: '20.09.2024, 12:35',
    title: 'Необходимо загрузить договор с поставщиком.',
    roleLabel: 'Роль пользователя',
    userName: 'Иванов Александр Викторович',
  },
  {
    dateTime: '20.09.2024, 12:35',
    title: 'Заявка одобрена',
    roleLabel: 'Роль пользователя',
    userName: 'Иванов Александр Викторович',
  },
  {
    dateTime: '20.09.2024, 12:35',
    title: 'Заявка находится на проверке',
    roleLabel: 'Роль пользователя',
    userName: 'Иванов Александр Викторович',
  },
  {
    dateTime: '20.09.2024, 12:35',
    title: 'Заявка сохранена',
    roleLabel: 'Роль пользователя',
    userName: 'Иванов Александр Викторович',
  },
  {
    dateTime: '20.09.2024, 12:35',
    title: 'Заявка создана',
    roleLabel: 'Роль пользователя',
    userName: 'Иванов Александр Викторович',
  },
];

export function UserHistory() {
  return (
    <Card>
      <h2 className="text-2xl font-semibold text-gray-900">История</h2>

      <div className="my-6 border-t border-gray-200" />

      <div className="flex flex-col gap-3">
        {mockHistory.map((item, idx) => (
          <div
            key={`${item.dateTime}-${idx}`}
            className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between mb-3"
          >
            <div className="flex flex-col gap-1 md:w-[594px]">
              <p className="text-sm text-gray-500">{item.dateTime}</p>
              <p className="text-base font-medium text-gray-900">
                {item.title}
              </p>
            </div>

            <div className="flex flex-col gap-1 md:flex-1 md:text-right">
              <p className="text-sm text-gray-500">{item.roleLabel}</p>
              <p className="text-base font-medium text-gray-900">
                {item.userName}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
